import request from '@/router/axios';

export const add = (row) => {
  return request({
    url: '/api/produce/weidu-gps-position-data/insert',
    method: 'post',
    data: row
  })
}
export const update = (row) => {
  return request({
    url: '/api/produce/weidu-gps-position-data/update',
    method: 'post',
    data: row
  })
}
export const getDetail = (id) => {
  return request({
    url: '/api/produce/weidu-gps-position-data/selectId',
    method: 'get',
    params: {
      id
    }
  })
}
export const getList = (params) => {
  return request({
    url: '/api/produce/weidu-gps-position-data/selectPage',
    method: 'get',
    params
  })
}
export const remove = (ids) => {
  return request({
    url: '/api/produce/weidu-gps-position-data/deleteIds',
    method: 'get',
    params: {
      ids
    }
  })
}

